import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Breadcrumbs from "../../../components/breadcrumbs";
import Footer from "../../../components/footer";
import Button from '../../../components/button';
import {URL_GEOLOCALIZATION} from '../../../config';
import axios from "axios";
import {
    searchAssistControl, 
    createAssistControl, 
    CREATE_ASSIST_CONTROL, 
    clear_assist_control,
    updateAssistControl,
    UPDATE_ASSIST_CONTROL
} from '../../../redux/assist_control';
import {
    searchUsersStoresAccess,
    createUserStoreAccess,
    CREATE_STORE_ACCESS,
    updateUserStoreAccess,
    UPDATE_STORE_ACCESS,
    clear_store_access,
} from '../../../redux/stores_access';
import LoadingSpinner from "../../../components/loading-spinner";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Modal from "../../../components/modal";
import SelectInput from "../../../components/select";
import {searchActivitiesUser} from '../../../redux/activities';
import {SocketContext} from "../../../config/ws-client";

function inittDate() {
    try {
        let date = new Date();
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        var value = year + '-' + month + '-' + day;
        return value;
    } catch (e) {
        return null;
    }
}

const data_month = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
];

const data_day = [
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
    'Domingo',
];

const Init = () => {
    const dispatch = useDispatch();

    const _session_data = useSelector((state) => state.users_module._session_data);
    const {token, user} = useSelector((state) => state.users_module.login.data) || null;
    const _create_assist_control = useSelector((state) => state.assist_control_module._create_assist_control);
    const _update_assist_control = useSelector((state) => state.assist_control_module._update_assist_control);
    const _create_store_access = useSelector((state) => state.users_stores_access_module._create_store_access);
    const _update_store_access = useSelector((state) => state.users_stores_access_module._update_store_access);
    const _get_all_stores = useSelector((state) => state.stores_module._get_all_stores);
    const {socket} = useContext(SocketContext);

    const [user_data, setUserData] = useState({
        usuario: "",
        nombres: "",
        apellidos: "",
        correo: "",
        foto: "",
        grupo_permiso: {
            nombre: ""
        }
    });

    const [store, setStore] = useState({
        id: "",
        nombre: "",
        codigo: "",
    });

    const [idAssistControl, setIdAssistControl] = useState(0);
    const [idStoreAccess, setIdStoreAccess] = useState(0);
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [timeInitial, setTimeInitial] = useState('08:00:00');
    const [timeFinal, setTimeFinal] = useState('18:00:00');
    const [adressInitial, setAdreesInitial] = useState('');
    const [latitudeInitial, setLatitudeInitial] = useState('');
    const [latitudeFinal, setLatitudeFinal] = useState('');
    const [longitudeInitial, setLongitudeInitial] = useState('');
    const [longitudeFinal, setLongitudeFinal] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    // eslint-disable-next-line
    const [date, setDate] = useState(inittDate());
    const [storeaccess, setStoreAccess] = useState(false);
    const [marking, setMarking] = useState(false);
    const [markingInitial, setMarkingInitial] = useState(false);
    const [markingFinal, setMarkingFinal] = useState(false);
    const [modalMarkingFinal, setModalMarkingFinal] = useState(false);
    const [modalStoreAccessFinal, setModalStoreAccessFinal] = useState(false);
    const [newStoreAccess, setNewStoreAccess] = useState(false);
    const [stores, setStores] = useState([]);
    const [iniciadas, setIniciadas] = useState([]);
    const [pendientes, setPendientes] = useState([]);
    const [id_store, setIdStore] = useState(0);
    const [msgApi, setMsgApi] = useState('');

    useEffect(() => {
        if (_session_data && _session_data.data) {
            setUserData(_session_data.data);
        }
    }, [_session_data]);

    useEffect(() => {
        if (_get_all_stores && _get_all_stores.data && _get_all_stores.data.datos) {
            let v_stores = _get_all_stores.data.datos.filter((x) => (x.activo === true));
            setStores(v_stores);
        }
    }, [_get_all_stores]);

    socket.onmessage = ((message) => {
        const dataFromServer = JSON.parse(message.data);
        if (dataFromServer) {
            if (dataFromServer.type_message === 'ingreso' || dataFromServer.type_message === 'salida') {
                setMsgApi(dataFromServer.message);
            }
        }
    })

    async function assist_control() {
        // eslint-disable-next-line
        let params = "?usuario=" + user + '&&fecha=' + date;
        try {
            const response = await searchAssistControl(token, params);
            if (response && response.data && response.data.cantidad > 0) {
                let data = response.data.datos[0];
                setIdAssistControl(data.id);
                if (data.ubicacion_final && data.ubicacion_final.id) {
                    setTimeFinal(data.ubicacion_final.hora);
                    setMarkingFinal(true);
                    setMarkingInitial(false);
                    setMarking(false);                
                } else {
                    setMarkingFinal(false);
                    setMarkingInitial(true);
                    setMarking(false);
                }
            } else {
                setMarking(false);
                setMarkingInitial(false);
                setMarkingFinal(false);
            }
        } catch (e) {
            setMarking(false);
            setMarkingInitial(false);
            setMarkingFinal(false);
        }
    }

    async function getActivityUser() {
        setIsLoading(true);
        try {
            const response = await searchActivitiesUser(token);
            if (response && response.data) {
                let v = response.data;
                setIniciadas(v.iniciadas);
                setPendientes(v.pendientes);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }


    async function store_access() {
        // eslint-disable-next-line
        let params = "?usuario=" + user + '&&fecha=' + date;
        try {
            const response = await searchUsersStoresAccess(token, params);
            if (response && response.data && response.data.cantidad > 0) {
                let data = response.data.datos[0];
                setIdStoreAccess(data.id);
                if (data.ubicacion_inicial && data.ubicacion_inicial.id) {
                    if (data.ubicacion_final && data.ubicacion_final.id){
                        setNewStoreAccess(false);
                        setStoreAccess(false);
                        setMsgApi(data.mensaje_salida);
                    } else {
                        setNewStoreAccess(false);                
                        setStoreAccess(true);
                        setStore({
                            id: data.id_tienda,
                            nombre: data.nombre_tienda,
                            codigo: data.codigo_tienda
                        });
                        setMsgApi(data.mensaje_ingreso);
                    }

                } else {
                    setNewStoreAccess(false);
                    setStoreAccess(false);
                }
            } else {
                setNewStoreAccess(false);
                setStoreAccess(false);
            }
        } catch (e) {
            setNewStoreAccess(false);
            setStoreAccess(false);
        }
    }

    useEffect(() => {
        if (user) {
            assist_control();
            store_access();
            getActivityUser();
        }
        // eslint-disable-next-line
    }, [user]);

    useEffect(() => {
        var days = new Date().getDate();
        var weeks = new Date().getDay() - 1;
        var months = new Date().getMonth();
        var years = new Date().getFullYear();
        setLatitudeInitial('');
        setLongitudeInitial('');
        setAdreesInitial('');
        setTimeInitial('08:00:00');
        setDay(data_day[weeks]);
        setMonth(days + ' ' + data_month[months]);
        setYear(years);
        getGeolocation('initial');
        // eslint-disable-next-line
    }, []);

    function getGeolocation(type) {
        // setIsLoading(true);
        navigator.geolocation.getCurrentPosition(
            function (position) {
                if (type === 'initial') {
                    setLatitudeInitial(position.coords.latitude);
                    setLongitudeInitial(position.coords.longitude);
                    geodecoder(position.coords.latitude, position.coords.longitude)
                }
                if (type === 'final') {
                    setLatitudeFinal(position.coords.latitude);
                    setLongitudeFinal(position.coords.longitude);
                }
            },
            (err) => {
                console.log(err)
            },
            {enableHighAccuracy: false, timeout: 27000, maximumAge: 30000});
    }

    function geodecoder(latitude, longitude) {
        var config = {
            method: 'get',
            url:
                URL_GEOLOCALIZATION +
                '?format=jsonv2&lat=' +
                latitude +
                '&lon=' +
                longitude,
            headers: {},
        };
        axios(config)
            .then(function (response) {
                setAdreesInitial(response.data.display_name);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        if (_create_assist_control) {
            if (_create_assist_control.status === 201) {
                toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
                dispatch(clear_assist_control(CREATE_ASSIST_CONTROL));
                assist_control();
                setMarkingFinal(false);
                setMarkingInitial(true);
                setMarking(false);
                setIsLoading(false);
            } else if (_create_assist_control.status !== 0) {
                dispatch(clear_assist_control(CREATE_ASSIST_CONTROL));
                toast.error(_create_assist_control.message, {position: toast.POSITION.TOP_RIGHT});
                setIsLoading(false);
            }
        }
        // eslint-disable-next-line
    }, [_create_assist_control, dispatch]);

    function create_marking() {
        setIsLoading(true);
        dispatch(createAssistControl(token, {'usuario': user, 'latitud': latitudeInitial, 'longitud': longitudeInitial}));
    }

    useEffect(() => {
        if (_update_assist_control) {
            if (_update_assist_control.status === 200) {
                dispatch(clear_assist_control(UPDATE_ASSIST_CONTROL));
                assist_control();
                setMarkingFinal(true);
                setMarkingInitial(false);
                setMarking(false);
                setModalMarkingFinal(false);
                setIsLoading(false);
            } else if (_update_assist_control.status !== 0) {
                dispatch(clear_assist_control(UPDATE_ASSIST_CONTROL));
                toast.error(_update_assist_control.message, {position: toast.POSITION.TOP_RIGHT});
            }
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_assist_control, dispatch]);

    function update_marking() {
        setIsLoading(true);
        dispatch(updateAssistControl(token, idAssistControl, {'usuario': user, 'latitud': latitudeFinal, 'longitud': longitudeFinal}));
    }

    useEffect(() => {
        if (_create_store_access) {
            if (_create_store_access.status === 201) {
                toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
                dispatch(clear_store_access(CREATE_STORE_ACCESS));
                store_access();
                setStoreAccess(true);
                setNewStoreAccess(false);
                setIsLoading(false);
            } else if (_create_store_access.status !== 0) {
                dispatch(clear_store_access(CREATE_STORE_ACCESS));
                toast.error(_create_store_access.message, {position: toast.POSITION.TOP_RIGHT});
                setIsLoading(false);
            }
        }
        // eslint-disable-next-line
    }, [_create_store_access, dispatch]);

    function create_store_access() {
        setIsLoading(true);
        if (id_store === 0) {
            toast.error("Debe seleccionar una tienda", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createUserStoreAccess(token, {'usuario': user, 'id_tienda': id_store, 'latitud': latitudeInitial, 'longitud': longitudeInitial}));
    }

    useEffect(() => {
        if (_update_store_access) {
            if (_update_store_access.status === 200) {
                dispatch(clear_store_access(UPDATE_STORE_ACCESS));
                store_access();
                setStoreAccess(false);
                setNewStoreAccess(false);
                setIsLoading(false);
                setModalStoreAccessFinal(false);
            } else if (_update_store_access.status !== 0) {
                dispatch(clear_store_access(UPDATE_STORE_ACCESS));
                toast.error(_update_store_access.message, {position: toast.POSITION.TOP_RIGHT});
            }
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_store_access, dispatch]);

    function update_store_access() {
        setIsLoading(true);
        dispatch(updateUserStoreAccess(token, idStoreAccess, {'latitud': latitudeFinal, 'longitud': longitudeFinal}));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <div><ToastContainer/></div>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Inicio"
                            items={[{label: "Pantalla inicial", link: "/"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {marking ?
                                    <>
                                        <div className='text-center'>
                                            <p className='texto_30'>{day}</p>
                                            <p className='texto_24'>{month}</p>
                                            <p className='texto_16'>{year}</p>
                                        </div>
                                        <div className='text-center'>
                                            <img className='mt-2 img_marking'
                                                src={window.location.origin + "/base/app-assets/images/icon/marking.png"}
                                                alt="img"
                                            />
                                        </div>
                                        <div className='text-center mb-1'>
                                            <p className='texto_16 font-weight-bold'>Hora de inicio de jornada</p>
                                            <span className='border_clock texto_48'>{timeInitial}</span>
                                        </div>
                                        <div className='text-center'>
                                            <img className='ml-2'
                                                src={window.location.origin + "/base/app-assets/images/icon/position.png"}
                                                alt="img"
                                                height="30"
                                                width="30"
                                            />
                                            <span className="ml-1 texto_16">{adressInitial}</span>
                                        </div>
                                        <div className='text-center mt-1'>
                                            <Button disabled={isLoading} type="button" text="Confirmar" theme="calendar" classes="m-1" onChange={() => {
                                                create_marking();
                                            }}/>
                                        </div>
                                    </>
                                :
                                    markingInitial ?
                                        newStoreAccess ?
                                            <>
                                                <div className='text-center'>
                                                    <p className='texto_24'>Ingresar a</p>
                                                    <p className='texto_30'>Joyería</p>
                                                </div>
                                                <div className='text-center'>
                                                    <img className='mt-2 img_store'
                                                        src={window.location.origin + "/base/app-assets/images/icon/store_access.png"}
                                                        alt="img"
                                                    />
                                                </div>
                                                <div className='row justify-content-center mb-2'>
                                                    <div className='col-md-4 col-12'>
                                                        <div className="form-group">
                                                            <label>Tienda</label>
                                                            <SelectInput
                                                                id="id_tienda"
                                                                label="id_tienda"
                                                                name="Tienda"
                                                                value={id_store}
                                                                onChange={(e) => {setIdStore(parseInt(e.target.value))}}
                                                                options={stores ? stores.map((item) => ({
                                                                    name: item.nombre,
                                                                    id: item.id,
                                                                })) : []}
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                                <div className='text-center mb-1'>
                                                    <span className='border_clock texto_48'>{timeInitial}</span>
                                                </div>
                                                <div className='text-center'>
                                                    <img className='ml-2'
                                                        src={window.location.origin + "/base/app-assets/images/icon/position.png"}
                                                        alt="img"
                                                        height="30"
                                                        width="30"
                                                    />
                                                    <span className="ml-1 texto_16">{adressInitial}</span>
                                                </div>
                                                <div className='text-center mt-1'>
                                                    <Button disabled={isLoading} type="button" text="Ingresar" theme="calendar" classes="m-1" onChange={() => {
                                                        create_store_access();
                                                    }}/>
                                                </div>
                                            </>
                                        :
                                            <>
                                                <div className='row'>
                                                    {(msgApi) &&
                                                        <div className='col-12 mb-1'>
                                                            <div className='text-right'>
                                                                <span className='texto_24'  style={{background: '#FFC912', padding: '5px 20px'}}>{msgApi}</span>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className='col-12'>
                                                        <p className='texto_20'>Tienda Actual</p>
                                                    </div>
                                                    <div className='col-12'>
                                                        <div className='row border-card'>
                                                            <div className='col-md-6 col-sm-12'>
                                                                {storeaccess ? 
                                                                    <p className='texto_16 mt-2'>Ingresaste a la tienda {store.nombre}</p>
                                                                :
                                                                    <p className='texto_16 mt-2'>Actualmente  no has ingresado a ninguna tienda</p>
                                                                }
                                                            </div>
                                                            <div className='col-md-6 col-sm-12 text-right'>
                                                                {storeaccess ?
                                                                    <Button disabled={isLoading} type="button" text="Salir" theme="calendar" classes="m-1" onChange={() => {
                                                                        getGeolocation('final');
                                                                        setModalStoreAccessFinal(true);
                                                                    }}/>
                                                                :
                                                                    <>
                                                                        <Button disabled={isLoading} type="button" text="Terminar jornada" theme="danger" classes="m-1" onChange={() => {
                                                                            getGeolocation('final');
                                                                            setModalMarkingFinal(true);
                                                                        }}/>
                                                                        <Button disabled={isLoading} type="button" text="Ingresar" theme="calendar" classes="m-1" onChange={() => {
                                                                            setNewStoreAccess(true);
                                                                            setLatitudeInitial('');
                                                                            setLongitudeInitial('');
                                                                            setAdreesInitial('');
                                                                            getGeolocation('initial');
                                                                            setIdStore(0);
                                                                        }}/>
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-12'>
                                                        <p className='texto_20'>Actividades Iniciadas</p>
                                                    </div>
                                                    {iniciadas.length > 0 && (
                                                        iniciadas.map((item) => (
                                                            <div className="col-md-6 col-12 mb-1">
                                                                <div className="p-1 border-card">
                                                                    <div className="d-flex">
                                                                        <div className="ml-1">
                                                                            <span className="texto_20">{item.actividad}</span><br/>
                                                                            <strong className="texto_16">Subproceso: {item.subproceso}</strong><br/>
                                                                            <span className="texto_14">Fecha agendada: {item.fecha_agendada}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-12'>
                                                        <p className='texto_20'>Actividades pendientes hoy</p>
                                                    </div>
                                                    {pendientes.length > 0 && (
                                                        pendientes.map((item) => (
                                                            <div className="col-md-6 col-12 mb-1">
                                                                <div className="p-1 border-card">
                                                                    <div className="d-flex">
                                                                        <div className="ml-1">
                                                                            <span className="texto_20">{item.actividad}</span><br/>
                                                                            <strong className="texto_16">Subproceso: {item.subproceso}</strong><br/>
                                                                            <span className="texto_14">Fecha agendada: {item.fecha_agendada}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            </>
                                    : 
                                        <>
                                            <div className='text-center mb-2'>
                                                <p className='texto_24'>Hola</p>
                                                <p className='texto_30'>{user_data.nombres} {user_data.apellidos}</p>
                                                <p className='texto_16'>{user_data.grupo_permiso.nombre}</p>
                                            </div>
                                            {markingFinal ?
                                                <>
                                                    <div className='text-center'>
                                                        <p className='texto_16 font-weight-bold'>Ya haz finalizado tu jornada por hoy</p>
                                                        <img className='mt-2 img_final'
                                                            src={window.location.origin + "/base/app-assets/images/icon/final.png"}
                                                            alt="img"
                                                        />
                                                    </div>
                                                    <div className='text-center mb-1'>
                                                        <p className='texto_16 font-weight-bold'>Hora de fin de jornada</p>
                                                        <span className='border_clock texto_48'>{timeFinal}</span>
                                                    </div>
                                                </>
                                            :
                                                <>
                                                    <div className='text-center'>
                                                        <p className='texto_16 font-weight-bold'>Aún no has marcado el inicio de tu jornada</p>
                                                        <img className='mt-2 img_init'
                                                            src={window.location.origin + "/base/app-assets/images/icon/init.png"}
                                                            alt="img"
                                                        />
                                                    </div>
                                                    <div className='text-center mt-1'>
                                                        <Button type="button" text="Marcar" theme="calendar" classes="m-1" onChange={() => {
                                                            setMarking(true);
                                                        }}/>
                                                    </div>
                                                </>
                                            }
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modalMarkingFinal}>
                <div className="card-body">
                    <div className='text-center'>
                        <img className='ml-2'
                            src={window.location.origin + "/base/app-assets/images/icon/help.png"}
                            alt="img"
                            height="100"
                            width="100"
                        />
                        <p className='texto_20 mt-2'>¿Desea marcar el fin de la jornada?</p>
                    </div>
                    
                </div>
                <div className="card-footer text-center">
                    <button disabled={isLoading} onClick={() => {
                        update_marking();
                    }} className={`btn btn-calendar mb-1 button_div`}>Confirmar
                    </button>
                    <button type="button" onClick={() => {
                        setModalMarkingFinal(false);
                    }} className={`btn btn-outline-calendar button_div`}>Cancelar
                    </button>
                </div>
            </Modal>
            <Modal className="modal-main div-modal" show={modalStoreAccessFinal}>
                <div className="card-body">
                    <div className='text-center'>
                        <img className='ml-2'
                            src={window.location.origin + "/base/app-assets/images/icon/help.png"}
                            alt="img"
                            height="100"
                            width="100"
                        />
                        <p className='texto_20 mt-2'>¿Desea marcar la salida de la tienda?</p>
                    </div>
                    
                </div>
                <div className="card-footer text-center">
                    <button disabled={isLoading} onClick={() => {
                        update_store_access();
                    }} className={`btn btn-calendar mb-1 button_div`}>Confirmar
                    </button>
                    <button type="button" onClick={() => {
                        setModalStoreAccessFinal(false);
                    }} className={`btn btn-outline-calendar button_div`}>Cancelar
                    </button>
                </div>
            </Modal>
            <Footer/>
        </div>
    );
};

export default Init;
